module.exports = __webpack_public_path__ + "img/sundry_food_logo.9bdd8b5e.png";